/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Warm_Swift_Frog_DartInputs */

const en_warm_swift_frog_dart = /** @type {(inputs: Warm_Swift_Frog_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add`)
};

const de_warm_swift_frog_dart = /** @type {(inputs: Warm_Swift_Frog_DartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add" |
*
* @param {Warm_Swift_Frog_DartInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warm_swift_frog_dart = /** @type {((inputs?: Warm_Swift_Frog_DartInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warm_Swift_Frog_DartInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_warm_swift_frog_dart(inputs)
	return de_warm_swift_frog_dart(inputs)
});